import { useMutation } from "@tanstack/react-query";

import { useCurrentCompanyId, useCurrentJobId } from "@/hooks";
import { httpClient } from "@/lib/http";
import {
  CandidacyComment,
  CreateOrUpdateCandidacyCommentRequest,
  HttpResponse,
} from "@/types";

export function useUpdateCandidacyComment() {
  const currentCompanyId = useCurrentCompanyId();
  const currentJobId = useCurrentJobId();

  const mutation = useMutation({
    mutationFn: async ({
      candidacyCommentId,
      candidacyId,
      updateCandidacyCommentRequest,
    }: {
      candidacyCommentId: number;
      candidacyId: string;
      updateCandidacyCommentRequest: CreateOrUpdateCandidacyCommentRequest;
    }) => {
      // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
      const path = `companies/${currentCompanyId}/jobs/${currentJobId}/candidacies/${candidacyId}/candidacy_comments/${candidacyCommentId}`;
      const res = await httpClient.patch<
        CandidacyComment,
        HttpResponse<CandidacyComment>,
        CreateOrUpdateCandidacyCommentRequest
      >(path, updateCandidacyCommentRequest);

      return res.data;
    },
  });

  return mutation;
}
